import axios from 'axios';
import store from "@store";
import router from "@router";

export default (secure = true) => {
    // 1. Initialisation plus concise des headers
    const headers = {
        'Accept': 'application/json',
    };

    if (secure) {
        const user = store.state.currentUser;
        if (user?.jwt) {
            headers['Authorization'] = `token=${user.jwt}`;
        }
    }

    // 2. Création de l'instance
    const instance = axios.create({
        baseURL: secure ? process.env.VUE_APP_BASE_API_URL : process.env.VUE_APP_PUBLIC_API_URL,
        withCredentials: false,
        headers
    });

    // 3. Intercepteur allégé
    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error.response?.status;
            // Les téléchargements de fichier (responseType blob) gèrent eux-mêmes leurs erreurs
            // pour éviter une navigation globale vers /404 quand le fichier est introuvable.
            const isBlobDownload = error.config?.responseType === 'blob';

            // On cible uniquement les erreurs qui nécessitent une action spécifique
            if (status === 403) {
                router.push({ name: "unauthorized" });
            } else if (status === 401 && secure) {
                store.dispatch("logOutExpired");
            } else if (status === 404 && !isBlobDownload) {
                router.push({ name: '404' });
            }

            // Tout le reste (500, 599, erreurs réseau) passe ici
            return Promise.reject(error);
        }
    );

    return instance;
};